import { initMetaTag, setMetaTag } from '@modules/metaTag';
import { useDispatch } from '@stores';
import { IStoreMetaTag } from '@types';
import { useCallback } from 'react';

const useMetaTagActions = () => {
  const dispatch = useDispatch();

  const onInitMetaTag = useCallback(() => {
    dispatch(initMetaTag());
  }, [dispatch]);

  const onSetMetaTag = useCallback(
    (payload: Partial<IStoreMetaTag>) => {
      dispatch(setMetaTag(payload));
    },
    [dispatch]
  );

  return { onInitMetaTag, onSetMetaTag };
};

export default useMetaTagActions;
